
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","stroke-opacity":"0","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.364 8.205H5.636v-1.5h12.728v1.5zm-4.546 4.545H5.636v-1.5h8.182v1.5zm-5.09 6.653L12 22l3.273-2.597 3.214-.14A3.636 3.636 0 0022 15.627V5.636A3.636 3.636 0 0018.364 2H5.636A3.636 3.636 0 002 5.636v9.992a3.636 3.636 0 003.513 3.634l3.214.14zm3.272.682l2.721-2.16 3.708-.162h.007a2.136 2.136 0 002.064-2.135V5.636c0-1.18-.956-2.136-2.136-2.136H5.636c-1.18 0-2.136.956-2.136 2.136v9.992c0 1.152.913 2.096 2.064 2.135h.007l3.708.162L12 20.085z"}})])
          )
        }
      }
    